import React from 'react';
import kiran from "../../assets/testimonials/kiran.jpeg"
import mouleeshwaran from "../../assets/testimonials/mouleeshwaran.jpeg"
import sabareeshwaran from "../../assets/testimonials/sabareeshwaran.jpeg"

const Testimonials = () => {
  const basePosters = [
    {
      id: 1,
      name: 'Kiran Padmanaban',
      src: kiran,
      alt: 'Kiran Padmanaban UPSC CSE 2024 Results',
      bg: "bg-blue-50",
      textAccent: "text-blue-900"
    },
    {
      id: 2,
      name: 'Mouleeshwaran S',
      src: mouleeshwaran,
      alt: 'Mouleeshwaran S UPSC CSE AIR 410',
      bg: "bg-red-50",
      textAccent: "text-red-900"
    },
    {
      id: 3,
      name: 'Sabareeshwaran P',
      src: sabareeshwaran,
      alt: 'Sabareeshwaran P AIR 700',
      bg: "bg-green-50",
      textAccent: "text-green-900"
    },
  ];

  return (
    <section className="w-full py-24 px-6 relative overflow-hidden bg-white">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-50 rounded-full blur-3xl opacity-60 -translate-y-1/2 translate-x-1/3 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-red-50 rounded-full blur-3xl opacity-60 translate-y-1/2 -translate-x-1/3 pointer-events-none"></div>

      {/* Header Section */}
      <div className="max-w-4xl mx-auto text-center mb-16 relative z-10">
        <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-100 text-[#1a237e] text-sm font-bold tracking-wider uppercase shadow-sm">
          Success Stories
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 tracking-tight">
          Our Proud <span className="text-blue-700">Achievers</span>
        </h2>
        <p className="text-lg text-slate-600 font-medium max-w-2xl mx-auto leading-relaxed">
          Driven by dedication and guided by expert mentorship, our students have achieved outstanding results. View the inspiring paths they took to excellence.
        </p>
      </div>

      {/* Static Grid Container */}
      <div className="relative w-full max-w-6xl mx-auto z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 justify-items-center">
          {basePosters.map((poster) => (
            <div
              key={poster.id}
              className={`w-full max-w-[340px] lg:max-w-[380px] p-6 rounded-[2rem] transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-slate-200/50 group ${poster.bg}`}
            >
              {/* Image Frame */}
              <div className="relative overflow-hidden rounded-[1.5rem] bg-white w-full aspect-[3/4] flex items-center justify-center border border-white shadow-sm mb-6">
                <img
                  src={poster.src}
                  alt={poster.alt}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = `https://via.placeholder.com/600x840/ffffff/1e293b?text=${encodeURIComponent(poster.name)}`;
                  }}
                />
              </div>
              
              {/* Name Tag */}
              <div className="text-center">
                <h3 className={`text-xl font-extrabold ${poster.textAccent}`}>
                  {poster.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
